
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { moneyFormat } from "@/utils/util";
import { getMembershipStatistics } from "@/api/shouyin";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import SearchPopup from "./SearchPopup.vue";
import PieChart from "@/components/PieChart/index.vue";

// 会员分析详情
@Component({
  components: { DimensionSelect, SearchPopup, PieChart },
})
export class MemberAnalysisDetail extends Vue {
  @Getter companyId!: string;
  moneyFormat = moneyFormat;
  params = {};

  keyValue = "";
  dimension = "总览";
  dimensionValue = "";

  searchRes = null;
  options: any = {
    type: "percent",
    isSimple: false,
    data: [
      { name: "会员", value: "40", prop: "membershipOrderMoney" },
      { name: "非会员", value: "60", prop: "ordinaryOrderMoney" },
    ],
  };
  grid = [
    {
      label: "会员人数",
      value: 260,
      prop: "membershipNumber",
      isMoney: false,
      extraLabel: "新增会员",
      extraValue: 50,
      extraIsMoney: false,
      extraProp: "newMembershipNumber",
    },
    {
      label: "新增储值金额",
      value: 28000,
      prop: "topUpAmount",
      isMoney: true,
      extraLabel: "赠送金额",
      extraValue: 5600,
      extraIsMoney: true,
      extraProp: "giftAmount",
    },
    {
      label: "会员储值余额",
      value: 201580,
      prop: "storedValueBalance",
      isMoney: true,
    },
    {
      label: "会员积分余额",
      value: "1200",
      prop: "totalAvailablePoints",
      isMoney: true,
    },
  ];
  totalData: any = {};

  @Watch("params")
  onParamsChange() {
    this.getData();
  }

  // @Watch("searchRes")
  // onSearchResChange(newVal: any) {
  //   const { starttime, endtime } = newVal;
  //   console.log("会员分析详情", starttime, endtime, this.companyId);
  //   this.params = {
  //     queryTimeBegin: `${starttime} 00:00:00`,
  //     queryTimeEnd: `${endtime} 23:59:59`,
  //     queryType: this.dimensionValue,
  //     storeId: this.companyId,
  //   };

  //   // 获取数据
  //   this.getData();
  // }

  getData() {
    getMembershipStatistics({ ...this.params }, true).then((res) => {
      this.totalData = res.data;
      this.grid.forEach((item) => {
        item.value = res.data[item.prop];
        if (item.extraProp) {
          item.extraValue = res.data[item.extraProp];
        }
      });
      const total =
        res.data.membershipOrderMoney + res.data.ordinaryOrderMoney || 1;
      this.options.data.forEach((item) => {
        const v = res.data[item.prop] || 0;
        item.value = Math.round(Number(v / total) * 10000) / 100;
      });
      console.log("pieChartData", this.options);
    });
  }

  onDimensionConfirm(name: string, value: string) {
    console.log("onDimensionConfirm ***", name, value);
    this.dimension = name;
    this.dimensionValue = value;
    // 设置参数
    this.params = {
      ...this.params,
      queryType: value,
    };
  }

  onSearchConfirm(res) {
    this.searchRes = res;
    const { starttime, endtime } = res;
    console.log("会员分析详情", starttime, endtime, this.companyId);
    this.params = {
      queryTimeBegin: `${starttime} 00:00:00`,
      queryTimeEnd: `${endtime} 23:59:59`,
      queryType: this.dimensionValue,
      storeId: this.companyId,
    };

    // 获取数据
    // this.getData();
  }
  mounted() {
    const queryObj = this.$route.query;

    if (!Object.keys(queryObj).length || queryObj?.isWorkbench !== "1") {
      return;
    }

    const pObj: any = { ...this.params };

    const paramsStr = window.localStorage.getItem("WorkbenchParams");
    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.queryType = workbenchParams.dimension.orderType;
        this.dimension = workbenchParams.dimension.text;
        this.dimensionValue = workbenchParams.dimension.orderType;
      }
    }
    this.params = pObj;
  }
}
export default MemberAnalysisDetail;
